import { MdOutlineVolumeOff, MdOutlineVolumeUp } from 'react-icons/md'

// Autoplay doesn't work without user interaction. See: https://developer.chrome.com/blog/autoplay
export function VolumeIcon({
  enabled,
  onClick,
}: {
  enabled: boolean
  onClick: () => void
}) {
  return enabled ? (
    <MdOutlineVolumeUp
      size={40}
      style={{ cursor: 'pointer' }}
      onClick={onClick}
    />
  ) : (
    <MdOutlineVolumeOff
      size={40}
      style={{ cursor: 'pointer' }}
      onClick={onClick}
    />
  )
}
